import useIsMobileSize from 'src/hooks/useIsMobileSize';
import { DesktopLayout, WithoutHeader } from 'src/layout';

import { Wrapper, Container } from 'src/widgets/FeedFilter/SidebarShell';
import AIMonitoringBlock from 'src/widgets/FeedFilter/AIMonitoringBlock';
import { Paper, Typography, Box, IconButton, Collapse } from '@mui/material';
import { useState } from 'react';
import ChevroneUp from 'src/icons/ChevroneUp';

import Keywords, { type IKeywordsProps } from './Content';

export default function KeywordsScreen(_props: IKeywordsProps) {
    const isMobile = useIsMobileSize();
    const [openHint, setOpenHint] = useState(true);

    if (isMobile) {
        return (
            <WithoutHeader showBack>
                <Keywords {..._props} />
            </WithoutHeader>
        );
    }

    return (
        <DesktopLayout
            rightSidebar={
                <Wrapper
                    elevation={0}
                    square={true}
                >
                    <Container
                        elevation={0}
                        isDisabled={false}
                    >
                        <AIMonitoringBlock />
                        <Paper
                            elevation={0}
                            sx={{ p: 2, borderRadius: 2, background: '#fff', mt: 1, boxShadow: 'none !important' }}
                        >
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                mb={openHint ? 2 : 0}
                            >
                                <Typography
                                    variant="h5"
                                    fontWeight={700}
                                    color="primary.main"
                                    sx={{ fontSize: 20 }}
                                >
                                    Как добавить ключевые слова
                                </Typography>
                                <IconButton
                                    size="small"
                                    onClick={() => setOpenHint((o) => !o)}
                                >
                                    <Box
                                        sx={{
                                            width: 16,
                                            height: 16,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            transition: 'transform 0.2s',
                                            transform: openHint ? 'rotate(180deg)' : 'rotate(0deg)',
                                        }}
                                    >
                                        <ChevroneUp />
                                    </Box>
                                </IconButton>
                            </Box>
                            <Collapse in={openHint}>
                                <Typography
                                    variant="body2"
                                    sx={{ color: 'text.primary !important', mb: 1 }}
                                >
                                    Заполните список ключевых слов, по которым будет проводиться поиск лидов:
                                </Typography>
                                <ul style={{ margin: 0, paddingLeft: 20 }}>
                                    <li>
                                        <Typography
                                            variant="body2"
                                            sx={{ color: 'text.primary !important' }}
                                        >
                                            Используйте популярные и актуальные термины из вашей ниши.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography
                                            variant="body2"
                                            sx={{ color: 'text.primary !important' }}
                                        >
                                            Предпочитайте отдельные слова вместо фраз — система автоматически распознает
                                            склонения и формы слов.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography
                                            variant="body2"
                                            sx={{ color: 'text.primary !important' }}
                                        >
                                            Добавляйте каждое ключевое слово или фразу с новой строки.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography
                                            variant="body2"
                                            sx={{ color: 'text.primary !important' }}
                                        >
                                            Не добавляйте кавычки
                                        </Typography>
                                    </li>
                                </ul>
                                <Typography
                                    variant="body2"
                                    sx={{ mt: 2, color: 'text.secondary !important' }}
                                >
                                    Например:
                                    <br />
                                    Для юридических услуг добавьте: «юрист», «договор», «суд», «регистрация бизнеса»
                                </Typography>
                            </Collapse>
                        </Paper>
                    </Container>
                </Wrapper>
            }
        >
            <Keywords {..._props} />
        </DesktopLayout>
    );
}
